import { render, staticRenderFns } from "./ThirPartPay.vue?vue&type=template&id=46b9e2fa&scoped=true&"
import script from "./ThirPartPay.vue?vue&type=script&lang=js&"
export * from "./ThirPartPay.vue?vue&type=script&lang=js&"
import style0 from "./ThirPartPay.vue?vue&type=style&index=0&id=46b9e2fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b9e2fa",
  null
  
)

export default component.exports